import PropTypes from "prop-types";

export default {
	canvas: PropTypes.instanceOf(Element),
};
